export default "__VITE_ASSET__Ei3JVj5k__"